// extracted by mini-css-extract-plugin
export default {"container":"Daily_container__k0ybb","flipping":"Daily_flipping__h-Yzf","link":"Daily_link__p+JKp"};